/**
 * File: ProductDetailPage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v2.6.1
 * Created: 2025-08-29
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useNavigate } from "react-router-dom";
import { useState } from "react";

// Local project files
import { ChatButton } from "../components/ui/Buttons";
import { ImageHero } from "../components/layout/Hero";
import { routes } from "../constants/routes";
import AccordionList from "../components/layout/AccordionList";
import Article from "../components/layout/Article";
import BuildTable from "../utils/BuildTable";
import CallToAction from "../components/layout/CallToAction";
import ContactModal from "../components/layout/ContactModal";
import PlanCard from "../components/ui/PlanCard";
import QuoteModal from "../components/layout/QuoteModal";

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function ProductDetailPage({ schema }) {
    const navigate = useNavigate();

    const [contactModal, setContactModal] = useState(false);
    const [quoteModal, setQuoteModal] = useState(false);

    const redirectSignUpPage = () => {
        navigate(routes.public.auth.signUp.abs);
    };

    const toggleContactModal = () => {
        setContactModal((prev) => !prev);
    };

    const closeContactModal = () => {
        setContactModal(false);
    };

    const toggleQuoteModal = () => {
        setQuoteModal((prev) => !prev);
    };

    const closeQuoteModal = () => {
        setQuoteModal(false);
    };

    return (
        <>
            {quoteModal && <QuoteModal onClose={closeQuoteModal} />}
            {contactModal && <ContactModal onClose={closeContactModal} />}
            <ChatButton onClick={toggleContactModal} />

            <div key={schema.meta.id} className="product-detail-page">
                <article className="product-detail-page__hero-article u-fade-in">
                    <div className="product-detail-page__container">
                        <ImageHero
                            {...schema.hero}
                            primaryOnClick={redirectSignUpPage}
                            secondaryOnClick={toggleQuoteModal}
                        />
                    </div>
                </article>
                <article className="product-detail-page__plan-card-article u-fade-in">
                    <div className="product-detail-page__container">
                        <PlanCard {...schema.planCard} />
                    </div>
                </article>
                {schema.articles.map((article) => (
                    <article
                        key={article.id}
                        className="product-detail-page__feature-article u-fade-in u-text-appear"
                    >
                        <div className="product-detail-page__container">
                            <Article type={"feature"} data={article} />
                        </div>
                    </article>
                ))}
                <article
                    id="comparison-table"
                    className="product-detail-page__comparision-article u-fade-in u-text-appear"
                >
                    <div className="product-detail-page__container">
                        <div className="product-detail-page__table">
                            <h2>Compare Packages</h2>
                            <BuildTable
                                object={schema.comparisonTable.object}
                                transpose
                                transposeHeader={
                                    schema.comparisonTable.transposeHeader
                                }
                            />
                        </div>
                    </div>
                </article>
                <article className="product-detail-page__faq-article">
                    <div className="product-detail-page__container">
                        <div className="product-detail-page__faq-headers">
                            <h2>Frequently Asked Questions</h2>
                            <AccordionList panels={schema.faq} />
                        </div>
                    </div>
                </article>
                <article className="product-detail-page__cta-article">
                    <div className="product-detail-page__container">
                        <CallToAction {...schema.cta} />
                    </div>
                </article>
            </div>
        </>
    );
}

export default ProductDetailPage;
